const ReviewData = [
    {
        id: 1,
        name: 'Fareda Edwards',
        stars: 5,
        description: "This is my go to for Asian food😃 I also love there Boba drinks.  My favorite on the menu is #44-45 short ribs,salad, rice, and egg, with egg roll. Yummy! The young servers are so friendly and very attentive to all there customers! Must try👍🏼👍🏼",
    },
    {
        id: 2,
        name: 'James Connelly',
        stars: 5,
        description: "I used to go here all the time back when I worked in the area, now I'm working again in the area and the food is still very good and reasonably priced, with today's increasing prices. Staff is friendly and tentative to your needs.",
    },
    {
        id: 3,
        name: 'Bailey Holden',
        stars: 5,
        description: "Had been craving Pad Thai & Spring rolls from here. Went in for some lunch this past weekend and boy did it satisfy. Like always the spring rolls were so fresh and the pad thai was chefs kiss. Always such amazing food and great employees",
    },
    {
        id: 4,
        name: 'Clay Smith',
        stars: 5,
        description: "Awesome menu with diverse choice and consistent quality. I particularly love the rice plates and my girlfriend almost always gets pho. Spring rolls are packed with protein so we rarely skip those as well."
    },
];

export default ReviewData;